// extracted by mini-css-extract-plugin
export default {"image-container":"UserImage_image-container__gDNIc","user-photo":"UserImage_user-photo__-4--1"};